import { Component, OnInit, OnDestroy } from '@angular/core';
import { ParkUsageService } from '../../statistics/park-usage.service';
import { Observable, Subscription } from 'rxjs';
import { ParametersService } from '../../services/parameters.service';

@Component({
  selector: 'app-park-usage',
  templateUrl: './park-usage.component.html',
  styleUrls: ['./park-usage.component.css']
})
export class ParkUsageComponent implements OnInit, OnDestroy {
  today : number;
  currentWeek : number;
  currentMonth : number;
  yesterday : number;
  lastWeek : number;
  lastMonth : number;

  subscription : Subscription;

  constructor(private parkUsageStat : ParkUsageService,
              private paramService : ParametersService) { }

  ngOnInit() {
    this.reloadData();

    this.subscription = Observable.interval(this.paramService.dashboardRefreshInterval).subscribe(() => this.reloadData());
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  reloadData() {
    this.parkUsageStat.getTodayStat().subscribe(data => this.today = data.nbTripsCurrentDay);
    this.parkUsageStat.getCurrentWeekStat().subscribe(data => this.currentWeek = data.nbTripsCurrentWeek);
    this.parkUsageStat.getCurrentMonthStat().subscribe(data => this.currentMonth = data.nbTripsCurrentMonth);
    this.parkUsageStat.getYesterdayStat().subscribe(data => this.yesterday = data.nbTripsPreviousDay);
    this.parkUsageStat.getLastWeekStat().subscribe(data => this.lastWeek = data.nbTripsPreviousWeek);
    this.parkUsageStat.getLastMonthStat().subscribe(data => this.lastMonth = data.nbTripsPreviousMonth);
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/park-usage/park-usage.component.ts